import React from "react";
import {
  ParagraphContentType,
  ParagraphTnc,
  TYPE_PARAGRAPH,
} from "../../../../components/paragraph-tnc";

import {
  IMG_PK_SHARIA_1,
  IMG_PK_SHARIA_2,
  IMG_PK_SHARIA_3,
  IMG_PK_SHARIA_4,
  IMG_PK_SHARIA_5,
  IMG_PK_SHARIA_6,
  IMG_PK_SHARIA_7,
} from "../../../../assets";

import {
  tcPkShariaPage1To20,
  tcPkShariaPage26To39,
  tcPromotionAAD,
} from "./pk-sharia-content.data";
import { TAgentDetail } from "../../pk-pmk-tnc.screen";
import { ImageView } from "../../../../components/image-view";

export const PKShariaContent = ({ agentDetail }: { agentDetail: TAgentDetail }) => {
  const { innerWidth } = window;

  const fontParagraph = "text-xs text-justify text-[#666666] font-semibold";
  const fontHeader = "text-sm text-justify text-[#666666] ";

  const getWidthImage = (width: number) => {
    if (width > innerWidth) {
      return innerWidth;
    } else {
      return width;
    }
  };
  return (
    <>
      <div className="px-4 py-3 text-center">
        <h1 className="text-base font-bold text-[#333333] ">PERJANJIAN KEAGENAN</h1>
        <h1 className="text-base font-bold text-[#333333]   ">
          PT PRUDENTIAL SHARIA LIFE ASSURANCE
        </h1>
      </div>
      <div className="px-4 ">
        <p className={fontParagraph}>
          PERJANJIAN KEAGENAN ini ("Perjanjian") dibuat oleh dan antara:
        </p>
        <div className="w-full flex flex-row mt-1 gap-1  ">
          <p className={`text-xs text-[#666666] font-semibold w-[5%] text-left bg-red`}>1.</p>
          <p className={`text-xs text-[#666666] font-semibold w-[15%]  text-left`}>Nama</p>
          <p className={`text-xs text-[#666666] font-semibold text-left`}>:</p>
          <p className={`text-xs text-[#666666] font-semibold w-[78%] text-left`}>
            PT PRUDENTIAL SHARIA LIFE ASSURANCE
          </p>
        </div>
        <div className="w-full flex flex-row gap-1">
          <p className={`text-xs text-[#666666] font-semibold w-[5%] text-left`}></p>
          <p className={`text-xs text-[#666666] font-semibold w-[15%] text-left`}>Alamat</p>
          <p className={`text-xs text-[#666666] font-semibold text-left`}>:</p>
          <p className={`text-xs text-[#666666] font-semibold w-[78%] text-left`}>
            Prudential Tower, Jl, Jendral Sudirman kav 79, Jakarta Selatan 12910
          </p>
        </div>
        <div className="w-full flex flex-row gap-1">
          <p className={`text-xs text-[#666666] font-semibold w-[5%] text-left`}></p>
          <p className={`text-xs text-[#666666] font-semibold w-[15%] text-left`}>No. Telp</p>
          <p className={`text-xs text-[#666666] font-semibold text-left`}>:</p>
          <p className={`text-xs text-[#666666] font-semibold w-[78%] text-left`}>
            (021) 2995 8577
          </p>
        </div>
        <p className={fontParagraph + " ml-[6%]"}>(selanjutnya disebut sebagai "Perusahaan")</p>
        <div className="w-full flex flex-row mt-1 gap-1  ">
          <p className={`text-xs text-[#666666] font-semibold w-[5%] text-left bg-red`}>2.</p>
          <p className={`text-xs text-[#666666] font-semibold w-[15%]  text-left`}>Nama</p>
          <p className={`text-xs text-[#666666] font-semibold text-left`}>:</p>
          <p className={`text-xs text-[#666666] font-semibold w-[78%] text-left`}>
            {agentDetail?.name || "-"}
          </p>
        </div>
        <div className="w-full flex flex-row gap-1">
          <p className={`text-xs text-[#666666] font-semibold w-[5%] text-left`}></p>
          <p className={`text-xs text-[#666666] font-semibold w-[15%] text-left`}>Alamat</p>
          <p className={`text-xs text-[#666666] font-semibold text-left`}>:</p>
          <p className={`text-xs text-[#666666] font-semibold w-[78%] text-left`}>
            {agentDetail?.address || "-"}
          </p>
        </div>
        <div className="w-full flex flex-row gap-1">
          <p className={`text-xs text-[#666666] font-semibold w-[5%] text-left`}></p>
          <p className={`text-xs text-[#666666] font-semibold w-[15%] text-left`}>No. Telp</p>
          <p className={`text-xs text-[#666666] font-semibold text-left`}>:</p>
          <p className={`text-xs text-[#666666] font-semibold w-[78%] text-left`}>
            {agentDetail?.phoneNumber || "-"}
          </p>
        </div>
        <p className={fontParagraph + " ml-[6%]"}>(selanjutnya disebut sebagai "Agen")</p>
        <p className={`${fontParagraph} mt-1`}>
          Perusahaan dan Agen secara bersama-sama selanjutnya dapat disebut "Para Pihak" dan secara
          sendiri-sendiri disebut "Pihak".
        </p>
        <p className={`${fontHeader} font-bold mt-1`}>BAHWA:</p>
        <p className={`${fontParagraph} mt-1 `}>
          Perusahaan bermaksud menunjuk Agen untuk melakukan pemasaran Produk Asuransi Syariah
          (sebagaimana didefinisikan di bawah ini) dan Agen bersedia untuk menerima penunjukan
          Perusahaan berdasarkan syarat-syarat dan ketentuan-ketentuan sebagaimana diatur dalam
          Perjanjian ini.
        </p>
        <p className={`${fontParagraph} mt-1 `}>
          Dengan tetap memperhatikan ketentuan dalam Perjanjian ini, Perjanjian akan dilaksanakan
          atas akad ju’alah, dimana Perusahaan berjanji dan berkomitmen untuk memberikan Imbalan (
          <i>reward</i>/`iwadh/ju`l) tertentu atas pencapaian hasil (<i>natijah</i>) yang ditentukan
          dari pelaksanaan Jasa oleh Agen sebagaimana diatur dalam Perjanjian ini (selanjutnya
          disebut “<b>Akad Ju’alah</b>”).
        </p>
        <p className={`${fontParagraph} mt-1`}>
          <b>MAKA</b>, dengan ini Para Pihak sepakat dan setuju atas syarat-syarat dan
          ketentuan-ketentuan sebagai berikut:
        </p>
        <ParagraphTnc
          content={tcPkShariaPage1To20 as ParagraphContentType[]}
          type={TYPE_PARAGRAPH.PARAGRAPH}
        />

        <p className={`${fontHeader} mt-1`}>
          <b>Lampiran I</b>
        </p>
        <p className={`${fontHeader} mt-1`}>
          <b>
            Ketentuan Komisi untuk <i>Agency</i>
          </b>
        </p>
        <p className={`${fontParagraph} mt-1`}>Produk Unit Link Syariah Kontribusi Berkala</p>
        <ImageView
          src={IMG_PK_SHARIA_1}
          alt="IMG_PK_SHARIA_1"
          className={`mt-0.5`}
          style={{ width: getWidthImage(600) }}
        />
        <p className={`${fontParagraph} mt-1`}>Produk Unit Link Syariah Kontribusi Tunggal</p>
        <ImageView
          src={IMG_PK_SHARIA_2}
          alt="IMG_PK_SHARIA_2"
          className={`mt-0.5 `}
          style={{ width: getWidthImage(350) }}
        />
        <p className={`${fontParagraph} text-[8px] text-left  mt-0.5 leading-[0.6rem]`}>
          Catatan: - Komisi untuk produk baru atau manfaat tambahan lainnya akan diinformasikan
          melalui Agency Update atau ketentuan Perusahaan lain secara tertulis.
        </p>

        <p className={`${fontHeader} mt-1`}>
          <b>Produk Syariah Tradisional</b>
        </p>
        <div className="flex flex-row mt-1 ml-[8px]">
          <p className={`${fontParagraph}  w-[5%]`}>1.</p>
          <div className="w-[95%] ">
            <p className={`${fontParagraph}  text-left`}>
              <b>PRUSolusi Sehat Syariah</b>
            </p>
            <ImageView
              src={IMG_PK_SHARIA_3}
              alt="IMG_PK_SHARIA_3"
              className={`mt-0.5`}
              style={{ width: getWidthImage(450) }}
            />
          </div>
        </div>
        <div className="flex flex-row mt-1 ml-[8px]">
          <p className={`${fontParagraph}  w-[5%]`}>2.</p>
          <div className="w-[95%] ">
            <p className={`${fontParagraph}  text-left`}>PRUCinta</p>
            <ImageView
              src={IMG_PK_SHARIA_4}
              alt="IMG_PK_SHARIA_4"
              className={`mt-0.5`}
              style={{ width: getWidthImage(430) }}
            />
          </div>
        </div>
        <div className="flex flex-row mt-1 ml-[8px]">
          <p className={`${fontParagraph}  w-[5%]`}>3.</p>
          <div className="w-[95%] ">
            <p className={`${fontParagraph}  text-left`}>PRUCerah</p>
            <ImageView
              src={IMG_PK_SHARIA_5}
              alt="IMG_PK_SHARIA_5"
              className={`mt-0.5`}
              style={{ width: getWidthImage(650) }}
            />
          </div>
        </div>

        {/* LAMPIRAN II */}

        <p className={`${fontHeader} mt-1.5`}>
          <b>Lampiran II</b>
        </p>
        <p className={`${fontHeader} mt-1`}>
          <b>Ketentuan Promosi</b>
        </p>
        <ImageView
          src={IMG_PK_SHARIA_6}
          alt="IMG_PK_SHARIA_6"
          className={`mt-0.5`}
          style={{ width: getWidthImage(900) }}
        />

        <p className={`${fontParagraph} mt-1.5`}>
          Berikut adalah ketentuan-ketentuan lain yang berlaku bagi promosi AAD:
        </p>

        <ParagraphTnc
          content={tcPromotionAAD as ParagraphContentType[]}
          type={TYPE_PARAGRAPH.NUMBERING}
        />

        <p className={`${fontParagraph} mt-1`}>
          Informasi lengkap terkait Ketentuan Promosi mengacu pada <i>Agency Update</i> yang
          berlaku.
        </p>
        <p className={`${fontParagraph} mt-1`}>
          <b>
            Validasi <i>Maintenance of Contract – MOC</i>
          </b>
        </p>
        <ImageView
          src={IMG_PK_SHARIA_7}
          alt="IMG_PK_SHARIA_7"
          className={`mt-0.5`}
          style={{ width: getWidthImage(750) }}
        />

        <p className={`${fontParagraph} mt-1`}>
          Ketentuan Promosi dan Validasi <i>MOC</i> dapat sewaktu-waktu berubah mengikuti ketentuan
          yang ditetapkan oleh Perusahaan melalui Peraturan Keagenan.
        </p>
        {/* LAMPIRAN III */}
        <p className={`${fontHeader} mt-1.5`}>
          <b>Lampiran III</b>
        </p>
        <p className={`${fontHeader} mt-1`}>
          <b>Syarat dan Ketentuan Perjanjian Keagenan </b>
        </p>
        <p className={`${fontHeader} mt-0.5`}>
          <b>Standar Praktik Kode Etik Agen Asuransi Jiwa Syariah</b>
        </p>
        <p className={`${fontHeader} mt-0.5`}>
          <b>LATAR BELAKANG </b>
        </p>
        <p className={`${fontParagraph} mt-1`}>
          Perusahaan menyadari pentingnya reputasi yang baik. Untuk memelihara reputasi yang baik
          dibutuhkan tanggung jawab dan profesionalisme tinggi dari setiap pelaku bisnis yang
          terlibat karena asuransi adalah bidang usaha yang berlandaskan pada kepercayaan dan
          kejujuran.
        </p>
        <p className={`${fontParagraph} mt-1`}>
          Prinsip-prinsip usaha dari Perusahaan adalah tindakan yang bertanggung jawab dengan
          integritas yang baik, patuh dengan hukum dan peraturan serta menghormati budaya dan
          tradisi masyarakat Indonesia. Agen Asuransi Jiwa Syariah Perusahaan (“Agen”) sebagai salah
          satu pelaku bisnis asuransi yang berpengaruh terhadap reputasi Perusahaan harus dilengkapi
          dengan suatu Kode Etik dan Perilaku untuk menghindari benturan kepentingan, penyalahgunaan
          jabatan dan penyalahgunaan informasi.
        </p>
        <p className={`${fontParagraph} mt-1`}>
          Standar Praktik Kode Etik Agen Asuransi Jiwa Syariah ini (“Kode Etik”) ditujukan agar
          setiap Agen selalu bertindak dengan etis, konsisten dan penuh integritas sesuai dengan
          prinsip Perusahaan dalam membangun kepercayaan dari (calon) Nasabah. Yang dimaksud dengan
          Nasabah dalam Standar Praktik Kode Etik Agen Asuransi Jiwa Syariah adalah Nasabah
          sebagaimana didefinisikan dalam Perjanjian, Peserta atau Penerima Manfaat. Selain itu,
          kepatuhan Agen terhadap hukum dan peraturan serta rasa hormat terhadap tradisi dan budaya
          Indonesia mencerminkan bahwa praktik penjualan akurat, lengkap, berimbang dan memenuhi
          etika standar. Dengan demikian Kode Etik ini wajib dipatuhi oleh setiap Agen dalam
          menjalankan profesinya.
        </p>
        <ParagraphTnc
          content={tcPkShariaPage26To39 as ParagraphContentType[]}
          type={TYPE_PARAGRAPH.PARAGRAPH}
        />
        <div className="mt-14">
          <p className={`${fontParagraph} mt-1.5 text-end`}>PAO/PK/S/V1021</p>
        </div>
      </div>
    </>
  );
};
